import useTranslationHook from "hooks/useTranslationHook";
import style from "./LoginModalTilte.module.scss";
import ArrowLeftIcon from "@Icons/ArrowLeftIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const ModalTitle = ({
  loginModalTitle = "",
  onBack = () => null,
  shouldBack = false,
}: {
  loginModalTitle: string;
  onBack: () => void;
  shouldBack: boolean;
}) => {
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  const loginText = isWhitelabel ? "Login" : t("home.herosection.login.logintoamber");

  return (
    <>
      {shouldBack ? (
        <div className={style.titleWrapper}>
          <span role="none" className={style.backIcon} onClick={onBack}>
            <ArrowLeftIcon height="20px" width="20px" />
          </span>
          <span className={formatClassNames(isWhitelabel ? "wl-title-font" : "")}>
            {loginModalTitle || loginText}
          </span>
        </div>
      ) : (
        <span className={formatClassNames(isWhitelabel ? "wl-title-font" : "")}>
          {loginModalTitle || loginText}
        </span>
      )}
    </>
  );
};

export default wrapperHOC(ModalTitle, {
  componentName: "ModalTitle-Login-Global",
  showForChina: true,
});
